import env from '@/config/env';
import ModeloDetalhado from '@/graphql/tabela/queries/ModeloDetalhado.gql'
import BuscaSimilar from '@/graphql/tabela/queries/BuscaSimilar.gql'
import {errorGQLHandler} from '@/helpers/helpers';
import {map, extend, findWhere} from 'lodash';

const Types = {
  MODELO: 'MODELO',
  CLEAR_MODELO: 'CLEAR_MODELO',
  LOADING: 'LOADING',
  LOADING_SIMILAR: 'LOADING_SIMILAR',
  SIMILARES: 'SIMILARES',
};

export default {
  namespaced: true,
  state: {
    loading: true,
    loadingSimilar: false,
    modelo: null,
    similares: {
      data: [],
      paginate: {},
    },
    range: 500,
  },
  getters: {
    loading: state => state.loading,
    loadingSimilar: state => state.loadingSimilar,
    modelo: state => state.modelo,
    similares: state => state.similares,
  },
  mutations: {
    [Types.MODELO](state, payload) {
      state.modelo = payload.data;
    },
    [Types.CLEAR_MODELO](state) {
      state.modelo = null
    },
    [Types.LOADING](state, payload) {
      state.loading = payload.loading;
    },
    [Types.LOADING_SIMILAR](state, payload) {
      state.loadingSimilar = payload.loadingSimilar;
    },
    [Types.SIMILARES](state, payload) {
      state.similares = payload.similares;
    }
  },
  actions: {
    async getModelo({commit, dispatch}, {tabela, renova, modelo, tipo}) {
      commit(Types.LOADING, {loading: true});
      commit(Types.LOADING_SIMILAR, {loadingSimilar: true});
      await commit(Types.CLEAR_MODELO);
      try {
        console.log(modelo)
        console.log(typeof modelo)
        const query = await env.tabela.query({
          query: ModeloDetalhado,
          variables: {
            tabela,
            modelo,
            tipo
          },
          fetchPolicy: 'no-cache',
        });

        /**
         * Buscar os Planos
         */
        await dispatch('vcPlano/getPlanos', { tabela, renova, modelo }, { root: true });

        /**
         * Check is 'smartphone'
         */

        let [data] = query.data.response.data;
        data = { ...data, tipo }

        if(tipo === 'smartphone')
          dispatch('getSimilar', {tabela, modelo, valor: data.preco});

        commit(Types.LOADING, {loading: false});
        commit(Types.MODELO, {data});
      } catch (e) {
        errorGQLHandler(e);
      }
    },
    async getSimilar({commit, state}, {tabela, modelo, valor}) {

      try {
        const range = state.range || 100;

        const query = await env.tabela.query({
          query: BuscaSimilar,
          variables: {
            tabela,
            modelo,
            valor,
            range
          },
          fetchPolicy: 'no-cache',
        });

        const { data, ...paginate } = query.data.response;

        commit(Types.SIMILARES, { similares: { data, paginate } });
        commit(Types.LOADING_SIMILAR, {loadingSimilar: false});
      } catch (e) {
        console.log(e)
        errorGQLHandler(e);
      }
    }
  }
}
